import React from 'react';
import ReactHtmlParser from 'html-react-parser';
import DOMPurify from 'dompurify';

// Allow <iframe> and its attributes in the admin RHC HTML; ADD_TAGS/ADD_ATTR extend
// DOMPurify's safe defaults so other elements' href/class/id/style still work.
const RHC_SANITIZE_CONFIG = {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
        'target', 'href', 'class', 'id', 'style',
        'src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen',
        'allowtransparency', 'scrolling', 'referrerpolicy', 'sandbox', 'loading', 'title',
    ],
};

const RHC = ({ surveyJson, pageNo }) => {
    const pages = surveyJson?.pages;

    // Null safety: no pages
    if (!pages || pages.length === 0) return null;

    // Get current page's RHC content (fall back to showing all if pageNo not provided)
    const currentPage = typeof pageNo === 'number' ? pages[pageNo] : null;

    if (currentPage) {
        // Show only current page's RHC
        if (!currentPage.htmlRHC) return null;
        const sanitizedHtml = DOMPurify.sanitize(currentPage.htmlRHC, RHC_SANITIZE_CONFIG);
        return (
            <div className="container rhc-comp">
                <div className="item-container">
                    <div>
                        {ReactHtmlParser(sanitizedHtml)}
                    </div>
                </div>
            </div>
        );
    }

    // Fallback: show all pages' RHC if pageNo not available
    const hasAnyRhc = pages.some(p => p?.htmlRHC);
    if (!hasAnyRhc) return null;

    return (
        <div className="container rhc-comp">
            <div className="item-container">
                {pages.map((page, index) => {
                    if (!page?.htmlRHC) return null;
                    const sanitizedHtml = DOMPurify.sanitize(page.htmlRHC, RHC_SANITIZE_CONFIG);
                    return (
                        <div key={index}>
                            {ReactHtmlParser(sanitizedHtml)}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RHC;
